module.exports = __webpack_public_path__ + "static/datesimportantes-051a2fe020589ac2a48a0d983893bb15.png";